import Axios from "../../../../../api/axios/Axios";

const BASE_URL = "/api/talents/private";

export const getPrivateTalentPulseDataset = (sport) =>
  Axios.get(`${BASE_URL}/pulse/dataset/${encodeURIComponent(sport)}`);

export const getPrivateTalentPulse = (talentId) =>
  Axios.get(`${BASE_URL}/${talentId}/pulse`);

export const getPrivateTalentSportPulse = (talentId, talentSportId) =>
  Axios.get(`${BASE_URL}/${talentId}/sports/${talentSportId}/pulse`);

export const upsertPrivateTalentPulse = (talentId, talentSportId, answers) =>
  Axios.post(`${BASE_URL}/${talentId}/sports/${talentSportId}/pulse`, {
    answers,
  });

export const updatePrivateTalentPulseVisibility = (pulseId, isActive) =>
  Axios.put(`${BASE_URL}/pulse/${pulseId}/visibility`, {
    isActive,
  });

export const deletePrivateTalentPulse = (pulseId) =>
  Axios.delete(`${BASE_URL}/pulse/${pulseId}`);

export const getSharedTalentPulse = (talentTag) =>
  Axios.get(`/api/talents/shared/${encodeURIComponent(talentTag)}/pulse`);
